import axios from "@/api/http";

export function querySaleAndOrangevEmployee(token) {
  return axios({
    url: '/api/orangevPrivate/querySaleAndOrangevEmployee',
    method: 'post',
    headers: {
      'authorization': token
    }
  })
}


export function confirmEmployeeLoginInfo(token, data) {
  return axios({
    url: '/api/orangevPrivate/confirmEmployeeLoginInfo',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function cancelEmployeeLoginInfo(token) {
  return axios({
    url: '/api/orangevPrivate/cancelEmployeeLoginInfo',
    method: 'post',
    headers: {
      'authorization': token
    },
  })
}

export function querySales(token, data, cancelToken) {
  return axios({
    url: '/api/orangevPrivate/querySales',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: data,
    cancelToken
  })
}


